<script>
  export let message;
  export let details = null;
</script>

<div
  class="border border-red-500 text-center w-full px-2 py-4 text-red-500 font-semibold p-4 rounded-md shadow-md"
>
  {message}
  {#if details}
    <p class="font-normal text-xs">{details}</p>
  {/if}
</div>
